import styled from 'styled-components';

export const Content = styled.div`
  padding: 16px;
  box-sizing: border-box;
  background: #fff;
  color: #000;
  position: absolute;
  max-width: 480px;
  left: 0;
  top: 35px;
  border-radius: 16px;
  z-index: 100;
`;